import useSWR from "swr";
import { getDashboard } from "./api";
import type { UnifiedDashboardResponse } from "./types";

export function useDashboard(from: string, to: string) {
  return useSWR<UnifiedDashboardResponse>(
    from && to ? ["dashboard", from, to] : null,
    () => getDashboard(from, to)
  );
}
